import { UserIcon, CalendarIcon } from "@heroicons/react/solid";

const Book = (props) => {
    return (
        <div className="card flex flex-col w-48 xl:w-64 items-center bg-white overflow-hidden rounded-lg shadow-2xl">
            <img src={require(`../../assets/images/books/${props.img}`)} alt="book" className="w-48 xl:w-64 h-48 xl:h-72" />
            <div className="w-[96%] p-3 pb-6">
                <p className="font-bold mb-2 text-sm xl:text-base">{props.title}</p>
                <div className="flex text-xs xl:text-sm mb-1">
                    <UserIcon className="w-5 text-gray-600" />
                    نویسنده: {props.author}
                </div>
                <div className="flex text-xs xl:text-sm">
                    <CalendarIcon className="w-5 text-gray-600" />
                    سال انتشار: {props.year}
                </div>
            </div>
        </div>
    );
};

export default Book;
